import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { ReactComponent as ChevronDownIcon } from "../../../../../stack/environment/icons/chevron-down.svg";
import { ReactComponent as ChevronRightIcon } from "../../../../../stack/environment/icons/chevron-right.svg";

export default function RemediationCollapseSection({
  title,
  children,
  defaultCollapsed = true,
}) {
  const colors = useColors();
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        display="flex"
        gap={1}
        alignItems="center"
        onClick={() => setCollapsed((prev) => !prev)}
        sx={{ cursor: "pointer" }}
        width="max-content"
      >
        <SvgToIcon
          IconLogo={collapsed ? ChevronRightIcon : ChevronDownIcon}
          width="20px"
          style={{ color: colors.active }}
        />
        <Typography variant="subtitle1">{title}</Typography>
      </Box>

      <Collapse in={!collapsed}>{children}</Collapse>
    </Box>
  );
}
